/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

export type PartnerStatementPdfRequest = {
  invoiceId: string;
};

export type PartnerStatementPdfResponse = {
  success: boolean;
  errorMessage: string;
  StatementPDF: string;
};

type ReturnTuple = [
  PartnerStatementPdfResponse | undefined,
  (requestParams: PartnerStatementPdfRequest) => void,
  () => void,
];

function useFetchPartnerStatementPdf({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<PartnerStatementPdfRequest>();
  const [response, setResponse] = useState<PartnerStatementPdfResponse>();
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: PartnerStatementPdfRequest) => {
      setDataFetchingInfo(true, 'creating pdf', 'fullScreen');

      const { Success, ErrorMessage, StatementPDF } = await api.fetchPartnerStatementPdf(
        buildParams(requestParams),
        source,
      );

      const res = {
        success: Success,
        errorMessage: ErrorMessage,
        StatementPDF: StatementPDF,
      };

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: PartnerStatementPdfRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setResponse(undefined);
      setSendRequest(false);
    },
  ];

  function buildParams(requestParams: PartnerStatementPdfRequest): vp.PartnerStatementPdfRequest {    
    return {
      InvoiceID: requestParams.invoiceId,
    };
  }
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchPartnerStatementPdf);
